/**
 * Regenerated image files keep their names, and scripts/deploy.mjs caches images for a week,
 * so a browser that already has the old file goes on showing it. Bumping a family's version
 * here adds `?v=` to its URLs, and every browser fetches the new files. The site serves the
 * same file either way; the query only changes the browser's cache key.
 */
export const LOGO_VERSION = "2"; // 2026-09-25: client logos cut to their marks
export const PORTRAIT_VERSION = "3"; // 2026-09-26: new portrait for Tal Simchony

export const withVersion = (url, version) => (version ? `${url}?v=${version}` : url);
